/** API route and global cache bucket (matches RoosterEditor.vue). */
export const QUICK_TEXT_CACHE_KEY = 'Apps/QuickText/GetQuickTextList';

/**
 * @param {*} api — HTTP client with `.get(route)`
 * @param {object} utils — Shared utils with global_variables
 */
export async function loadQuickTextList(api, utils) {
    if (!('RoosterCache' in utils.global_variables))
        utils.global_variables.RoosterCache = {};

    let rows = utils.global_variables.RoosterCache[QUICK_TEXT_CACHE_KEY];
    if (!Array.isArray(rows)) {
        rows = await api.get(QUICK_TEXT_CACHE_KEY);
        utils.global_variables.RoosterCache[QUICK_TEXT_CACHE_KEY] = rows;
    }

    if (!Array.isArray(rows)) {
        if (Array.isArray(rows?.Data))
            rows = rows.Data;
        else if (Array.isArray(rows?.data))
            rows = rows.data;
        else if (Array.isArray(rows?.Items))
            rows = rows.Items;
        else
            rows = [];
    }

    return rows.map(normalizeQuickTextItem);
}

export function normalizeQuickTextItem(item) {
    const rawTags = item?.Tags;
    const tags = Array.isArray(rawTags)
        ? rawTags.map((t) => String(t)).filter(Boolean)
        : (typeof rawTags === 'string' ? rawTags.split(',').map((t) => t.trim()).filter(Boolean) : []);

    const payload = item?.Text;
    let richHtml = '';
    let plainText = '';

    if (payload && typeof payload === 'object') {
        richHtml = payload.RichText || payload.Html || '';
        plainText = payload.PlainText || payload.Text || '';
    }
    else if (typeof payload === 'string') {
        if (/<[^>]+>/.test(payload)) {
            richHtml = payload;
            plainText = htmlToPlainText(payload);
        }
        else {
            plainText = payload;
        }
    }

    if (!plainText && richHtml)
        plainText = htmlToPlainText(richHtml);

    return {
        title: item?.Title || plainText || 'Untitled quick text',
        tags,
        plainText,
        richHtml,
        icon: 'mdi-text',
    };
}

export function htmlToPlainText(html) {
    if (!html)
        return '';
    if (typeof document === 'undefined')
        return String(html).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
    const temp = document.createElement('div');
    temp.innerHTML = html;
    return (temp.textContent || temp.innerText || '').trim();
}

export function getItemInsertPayload(item) {
    if (!item)
        return { richHtml: '', plainText: '' };

    const normalizedRich = (typeof item.richHtml === 'string') ? item.richHtml : '';
    const normalizedPlain = (typeof item.plainText === 'string') ? item.plainText : '';
    if (normalizedRich || normalizedPlain)
        return { richHtml: normalizedRich, plainText: normalizedPlain };

    const legacyContent = item.content || item.Text || null;
    if (legacyContent && typeof legacyContent === 'object') {
        return {
            richHtml: legacyContent.RichText || legacyContent.Html || '',
            plainText: legacyContent.PlainText || legacyContent.Text || '',
        };
    }

    if (typeof legacyContent === 'string') {
        return {
            richHtml: /<[^>]+>/.test(legacyContent) ? legacyContent : '',
            plainText: /<[^>]+>/.test(legacyContent) ? htmlToPlainText(legacyContent) : legacyContent,
        };
    }

    return {
        richHtml: '',
        plainText: typeof item.title === 'string' ? item.title : '',
    };
}
